// extracted by mini-css-extract-plugin
export default {"label":"VehiclePayments-module__label--MEGzM"};